import { HubConnection, HubConnectionBuilder } from '@aspnet/signalr'

type Action = (connection: HubConnection) => void
type ErrorAction = (reason: object) => void

export class SignalRService {
  private connection: HubConnection

  constructor(endpoint: string) {
    this.connection = new HubConnectionBuilder().withUrl(endpoint).build()
  }

  start(resolve: Action, reject: ErrorAction) {
    return this.connection
      .start()
      .then(() => resolve(this.connection))
      .catch(reject)
  }

  stop(resolve: Action, reject: ErrorAction) {
    return this.connection
      .stop()
      .then(() => resolve(this.connection))
      .catch(reject)
  }
}



// WEBPACK FOOTER //
// ./src/modules/signal-r/signal-r.service.ts